import { Box, CardContent, Grid, Table, TableHead, TableRow, TableBody, CircularProgress } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import HealthConditionItem from './ListItem'
import { useEffect } from 'react'
import { search, clearConditions } from 'store/nurse/nurse-health-condition'
import TableHeadCell from 'components/TableHeadCell'
import NoRecords from 'components/NoRecords'
import { LightbulbTwoTone } from '@mui/icons-material'

const headers = ['Visibility', 'Type', 'Explanation', 'Medication', 'Administer', 'Actions']
export default function HealthConditionsList({ selected }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const healthConditions = useSelector(state => state.nurse.healthCondition.list)


  useEffect(() => {
    if (selected) {
      dispatch(search({ studentId: selected.personId }))
    } else {
      dispatch(clearConditions())
    }
  }, [dispatch, selected])

  if (!selected) return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100px', textAlign: 'center', padding: '20px',}}>
        <NoRecords 
          icon={<LightbulbTwoTone sx={{fontSize: 50, color: "primary.main"}} />} 
          message="Please select a student from the field above to see or add new conditions for the selected student!" 
          sx={{ mt: 20 }}
          callout
          />
    </Box>
  )
  
  if (healthConditions === null) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box sx={{ display: 'flex', padding: '10px', flexDirection: 'column', alignItems: 'flex-start', gap: '10px' }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <CardContent sx={{ pr: 0, pl: 0 }}>
            <Table>
              <TableHead>
                <TableRow>
                    {headers.map((item, index) => (
                        <TableHeadCell key={index}>
                            {t(item)}
                        </TableHeadCell>
                    ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {healthConditions?.map(item => (
                  <HealthConditionItem key={item.id || item.uid} item={item} />
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Grid>
      </Grid>
    </Box>
  )
}
